export type FeedbackIcon = 'bug' | 'improve' | 'support';

export type FeedbackAction = { kind: 'contact' } | { kind: 'survey' };

export type FeedbackItem = {
  title: string;
  subtitle: string;
  icon: FeedbackIcon;
  action: FeedbackAction;
};

export const FEEDBACK_SURVEY_URL =
  'https://public.icxbee.ai/generic-survey?o=ORG-S062600007&q=SUR-QSR-S062600007-010726070724&t=mqTap';

export const FEEDBACK_PANEL = {
  title: 'How can we help?',
  surveyTitle: 'Share your experience',
  surveyText: 'Take a short survey about your visit. It opens in a new tab.',
  surveyCta: 'Take survey',
} as const;

export const FEEDBACK_ITEMS: FeedbackItem[] = [
  // {
  //   icon: 'bug',
  //   title: 'Report a bug',
  //   subtitle: 'Something not working? Tell us in a quick survey.',
  //   action: { kind: 'survey' },
  // },
  {
    icon: 'improve',
    title: 'Suggest improvements',
    subtitle: 'Share ideas to help us improve ICXBee.',
    action: { kind: 'survey' },
  },
  {
    icon: 'support',
    title: 'Get support',
    subtitle: 'Questions about services, projects, or partnerships.',
    action: { kind: 'contact' },
  },
];
